import React from 'react';
import { LuShieldAlert } from 'react-icons/lu';
import { useUserTrackSettings } from '../context/UserTrackSettingsContext';
import './UserPermissionNotice.css';

const UserPermissionNotice = () => {
  const { error, loading, refresh } = useUserTrackSettings();
  if (!error || loading) return null;

  return (
    <div className="ud-permission-notice" role="alert">
      <LuShieldAlert aria-hidden="true" />
      <span>
        <strong>Permission status is temporarily unavailable.</strong>
        {' '}{error}
      </span>
      <button type="button" onClick={refresh}>Retry</button>
    </div>
  );
};

export default UserPermissionNotice;
